<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4">CONTENTS</h4>
<p class="normal"><a href="#/06_9781614230755_Foreword">Foreword, by Raymond O. Polett</a></p>
<p class="normal"><a href="#/07_9781614230755_Acknowledgements">Acknowledgements</a></p>
<p class="normal"><a href="#/08_9781614230755_Introduction">Introduction, by Paul Ewasko and Lisa Caputo</a></p>
<p class="normal-a"><a href="#/09_9781614230755_CH01">A Bridge So Close, So Far</a></p>
<p class="normal"><span href="#/10_9781614230755_CH02" title="Link target outside of Sample">In Search of Freedom</span></p>
<p class="normal"><span href="#/11_9781614230755_CH03" title="Link target outside of Sample">Safe in America</span></p>
<p class="normal"><span href="#/12_9781614230755_CH04" title="Link target outside of Sample">A Drive to Darkness</span></p>
<p class="normal"><span href="#/13_9781614230755_CH05" title="Link target outside of Sample">Investigation to Nowhere, Part I</span></p>
<p class="normal"><span href="#/14_9781614230755_CH06" title="Link target outside of Sample">A Niece, a Reporter and a PI</span></p>
<p class="normal"><span href="#/15_9781614230755_CH07" title="Link target outside of Sample">Investigation to Nowhere, Part II</span></p>
<p class="normal-a"><span href="#/16_9781614230755_Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="normal"><span href="#/17_9781614230755_AppendixA" title="Link target outside of Sample">Appendix A. Family Letter to New York Governor George E. Pataki</span></p>
<p class="normal"><span href="#/18_9781614230755_AppendixB" title="Link target outside of Sample">Appendix B. Letters to David Hennigan</span></p>
<p class="normal"><span href="#/19_9781614230755_Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_9781614230755_Contents.vue?707de884